import dayjs, { type Dayjs } from 'dayjs'
import styles from './package.module.scss'
import type {
  PromotionRoom,
  PromotionSignContracts,
} from 'features/Home/Promotion/types/promotion.types'
import React from 'react'
import { usePlural } from 'hooks/use-plural'

type Props = {
  data: PromotionSignContracts
  showDatePeriod?: boolean
}

const getTotalSlots = (slots: number, isGrouped: boolean) => {
  if (isGrouped) {
    return slots / 5
  }
  return slots
}
const PackageDetails = ({ data, showDatePeriod = true }: Props) => {
  const convention = data?.summary?.convention
  const startDate = dayjs(convention?.contract_period?.start_date)
  const endDate = dayjs(convention?.contract_period?.end_date)
  const isGrouped = convention?.slot_usage === 1

  return (
    <div className={styles.packageDetails}>
      {convention?.rooms?.map((option, i) => {
        return (
          <React.Fragment key={`${option.name}_${i}`}>
            <PackageTemplate
              option={option}
              startDate={startDate}
              endDate={endDate}
              isGrouped={isGrouped}
              showDatePeriod={showDatePeriod}
            />
          </React.Fragment>
        )
      })}
      {convention?.options?.map((option, i) => {
        return (
          <div key={`${option.name}_${i}`}>
            <p className={styles.optionLabel}>{option.name}</p>
          </div>
        )
      })}
    </div>
  )
}

export default PackageDetails

export const PackageTemplate = ({
  option,
  startDate,
  endDate,
  isGrouped,
  showDatePeriod,
  showRoomName = true,
}: {
  startDate: Dayjs
  endDate: Dayjs
  isGrouped: boolean
  option: PromotionRoom
  showDatePeriod: boolean
  showRoomName?: boolean
}) => {
  const { getFormattedText } = usePlural()
  return (
    <div>
      {showRoomName && <p className={styles.optionLabel}>{option.name}</p>}
      {option.weekday_slots > 0 && (
        <span className={styles.optionDescription}>
          {getFormattedText(getTotalSlots(option.weekday_slots, isGrouped), {
            one: 'slot',
            other: 'slots',
          })}
          {` (${isGrouped ? 5 : 1}h/slot) ${option.slot_period}`} from
          <span className={styles.optionLabel}> Mon</span> to
          <span className={styles.optionLabel}> Fri</span>
          {showDatePeriod && (
            <>
              {' ('}
              <span className={styles.optionLabel}>{startDate.format("ddd, MMM DD,'25")}</span>
              {' - '}
              <span className={styles.optionLabel}>{endDate.format("ddd, MMM DD,'25")}</span>)
            </>
          )}
        </span>
      )}
      {option.weekend_slots > 0 && (
        <>
          <br />
          <span className={styles.optionDescription}>
            {getFormattedText(getTotalSlots(option.weekend_slots, isGrouped), {
              one: 'slot',
              other: 'slots',
            })}
            {` (${isGrouped ? 5 : 1}h/slot) ${option.slot_period}`} from
            <span className={styles.optionLabel}> Sat</span> to
            <span className={styles.optionLabel}> Sun</span>
            {showDatePeriod && (
              <>
                {' ('}
                <span className={styles.optionLabel}>{startDate.format("ddd, MMM DD,'25")}</span>
                {' - '}
                <span className={styles.optionLabel}>{endDate.format("ddd, MMM DD,'25")}</span>)
              </>
            )}
          </span>
        </>
      )}
    </div>
  )
}
